import { useSelector, shallowEqual } from 'react-redux';

import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import {
  selectIsLoading as selectIsLoadingQuote,
  selectErrors as selectQuoteErrors
} from 'state/quote/quote-slice';
import {
  selectIsLoading as selectLoadingJourneyDataAPI,
  selectErrors as selectJourneyDataAPIErrors
} from 'state/journey-data/journey-data-slice';
import { useJourneyData } from 'hooks/useJourneyData';
import { useIsEligibleCustomer } from 'hooks/useIsEligibleCustomer';

export const usePersonalInformationSummary = () => {
  const { consumption, address } = useJourneyData();

  const quoteInProgress = useSelector(selectIsLoadingQuote, shallowEqual);
  const quoteAPIErrors = useSelector(selectQuoteErrors, shallowEqual) || [];
  const jouenyDataInProgress = useSelector(
    selectLoadingJourneyDataAPI,
    shallowEqual
  );
  const journeyDataAPIErrors =
    useSelector(selectJourneyDataAPIErrors, shallowEqual) || [];
  const fuelType = useSelector(selectFuelType, shallowEqual);

  const { gas, electric } = fuelType;
  const isLoading = quoteInProgress || jouenyDataInProgress;
  const errors = [...quoteAPIErrors, ...journeyDataAPIErrors];
  const isEligibleCustomer = useIsEligibleCustomer();

  const fuelTypeText = [
    ...(gas ? ['Gas'] : []),
    ...(electric ? ['Electricity'] : [])
  ].join(' & ');

  return {
    address,
    fuelTypeText,
    fuelType,
    consumption,
    isEligibleCustomer,
    errors,
    isLoading
  };
};
